import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { postSurveyData } from '../../services/api';
import { setlocal, getlocal } from '../../../../../base/base/storage';

class TwoOption extends React.PureComponent {
    static propTypes = {
        surveyId: PropTypes.string,
        votecount: PropTypes.number,
        isExpire: PropTypes.bool,
        resultShow: PropTypes.bool,
        content: PropTypes.object,
        handleOptionSubmit: PropTypes.func,
        isSubmitSurvey: PropTypes.bool,
    };

    state = {
        itemid: '',
        resultShow: this.props.resultShow,
        votecount: this.props.votecount,
        hasLocal: false,
    };

    componentDidMount() {
        this.handleLocalData('didMount');
    }

    handleLocalData = (from) => {
        const {
            content: { questionid },
        } = this.props;
        const getlocalVal = getlocal('surveyResultData') || {};

        if (Object.keys(getlocalVal).includes(questionid)) {
            if (from === 'didMount') {
                this.setState({
                    hasLocal: true,
                });
            }
            this.setState({
                itemid: getlocalVal?.[questionid]?.[0],
                resultShow: true,
            });
        }
    };

    componentWillReceiveProps() {
        this.handleLocalData('updata');
    }

    handleSubmit = async (itemid) => {
        const {
            surveyId,
            votecount,
            content: { questionid },
            handleOptionSubmit,
        } = this.props;

        const survey = await postSurveyData(`sur[${questionid}][]=${itemid}`, surveyId);

        // 本地存储选中项目 begin
        const getlocalVal = getlocal('surveyResultData') || {};
        const selectValue = {
            [questionid]: [itemid],
        };

        setlocal('surveyResultData', {
            ...getlocalVal,
            ...selectValue,
        });

        if (handleOptionSubmit) {
            handleOptionSubmit();
        }
        // 本地存储选中项目 end

        this.setState({
            itemid,
            resultShow: true,
            votecount: votecount + 1,
        });

        window.alert(survey.msg);
    };

    getPercent = (selfItemid, num, nump) => {
        const { resultShow, hasLocal, itemid, votecount } = this.state;

        if (resultShow && !hasLocal && selfItemid === itemid) {
            return ((num + 1) * 100) / votecount;
        } else {
            return nump;
        }
    };

    render() {
        const { itemid, resultShow, votecount, hasLocal } = this.state;
        const {
            isExpire,
            content: { question, option, questionid },
            isSubmitSurvey,
        } = this.props;

        return (
            <div className={styles.box}>
                <div className={styles.title}>{question}</div>
                {resultShow ? (
                    <div className={styles.result}>
                        <div className={styles.result_item}>
                            <span>
                                <span className={itemid === option[0].itemid ? styles.icon_0 : ''}>
                                    {option[0].title.slice(0, 12)}
                                </span>
                            </span>
                            <span>
                                <span className={itemid === option[1].itemid ? styles.icon_1 : ''}>
                                    {option[1].title.slice(0, 12)}
                                </span>
                            </span>
                        </div>
                        <div className={styles.bar}>
                            <span style={{ width: `${option[0].nump - 0.25}%` }}>
                                <div className={styles.lbar} />
                            </span>
                            <span style={{ width: `${option[1].nump - 0.25}%` }}>
                                <div className={styles.rbar} />
                            </span>
                        </div>
                        <div className={styles.count}>
                            <span>
                                <span className={styles.countNum}>
                                    {Math.round(this.getPercent(option[0].itemid, option[0].num, option[0].nump))}%
                                </span>
                                <span className={styles.countPeo}>
                                    ({itemid === option[0].itemid && !hasLocal ? option[0].num + 1 : option[0].num}人)
                                </span>
                            </span>
                            <span>
                                <span className={styles.countNum}>
                                    {Math.round(this.getPercent(option[1].itemid, option[1].num, option[1].nump))}%
                                </span>
                                <span className={styles.countPeo}>
                                    ({itemid === option[1].itemid && !hasLocal ? option[1].num + 1 : option[1].num}人)
                                </span>
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className={styles.option}>
                        <span className={styles.item_0} onClick={() => this.handleSubmit(option[0].itemid)}>
                            <span>{option[0].title}</span>
                        </span>
                        <span className={styles.vs} />
                        <span className={styles.item_1} onClick={() => this.handleSubmit(option[1].itemid)}>
                            <span>{option[1].title}</span>
                        </span>
                    </div>
                )}
                <div className={styles.tips}>
                    <span>{`${votecount}人参与`}</span>
                    <span>{isExpire ? '抱歉，本调查已经结束' : '投票进行中'}</span>
                </div>
            </div>
        );
    }
}

export default TwoOption;
